import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from '@store/order/OrderState';
import { DeliveryTypeDef } from '@api/types/DeliveryTypeDef';
import { PaymentTypeDef } from '@api/types/PaymentTypeDef';
import { DispatchPoint } from '@api/types/DispatchPoint';
import { AppLanguageCode } from '@project-types/AppLanguageCodes';



export const orderSlice = createSlice({
	name: 'order',
	initialState,
	reducers: {
		setShowInvalids: (state, action: PayloadAction<boolean>) => {
			state.showInvalids = action.payload
		},
		setSizeA: (state, action: PayloadAction<number | null>) => {
			state.sizeA = action.payload;
		},
		setSizeB: (state, action: PayloadAction<number | null>) => {
			state.sizeB = action.payload;
		},
		setSizeC: (state, action: PayloadAction<number | null>) => {
			state.sizeC = action.payload;
		},
		setRace: (state, action: PayloadAction<string | null>) => {
			state.race = action.payload;
		},
		setAge: (state, action: PayloadAction<number | null>) => {
			state.age = action.payload;
		},
		setBehaviourDesc: (state, action: PayloadAction<string | null>) => {
			state.behaviourDesc = action.payload;
		},
		setSurgerySegment: (state, action: PayloadAction<string>) => {
			let segment = action.payload;

			if (state.surgerySegments.length === 0) {
				state.surgerySegments.push(segment);
				return;
			};

			let index = state.surgerySegments.findIndex(x => x === segment);
			if (index !== -1) {
				state.surgerySegments.splice(index, 1);
				return;
			};
			state.surgerySegments.push(segment);
		},
		setIssueDesc: (state, action: PayloadAction<string | null>) => {
			state.issueDesc = action.payload;
		},
		setSurgeryDate: (state, action: PayloadAction<string | null>) => {
			let onlyDate = action.payload ? !/T00:00:00$/.test(action.payload) : false; 
			state.surgeryDate = onlyDate ? `${action.payload}T00:00:00` : action.payload;
		},
		setName: (state, action: PayloadAction<string | null>) => {
			state.name = action.payload;
		},
		setEmail: (state, action: PayloadAction<string | null>) => {
			state.email = action.payload;
		},
		setPhoneNumber: (state, action: PayloadAction<string | null>) => {
			state.phoneNumber = action.payload;
		},

		setStreet: (state, action: PayloadAction<string | null>) => {
			state.street = action.payload;
		},
		setCity: (state, action: PayloadAction<string | null>) => {
			state.city = action.payload;
		},
		setPostalCode: (state, action: PayloadAction<string | null>) => {
			state.postalCode = action.payload;
		},
		setInvoiceStreet: (state, action: PayloadAction<string | null>) => {
			state.invoiceStreet = action.payload;
		},
		setInvoiceCity: (state, action: PayloadAction<string | null>) => {
			state.invoiceCity = action.payload;
		},
		setInvoicePostalCode: (state, action: PayloadAction<string | null>) => {
			state.invoicePostalCode = action.payload;
		},
		
		setSelectedType: (state, action: PayloadAction<number | null>) => {
			let previous = state.selectedType;
			let next = action.payload;
			if (!previous && next) {
				state.selectedType = action.payload;
				return;
			}
			if (previous && next && previous !== next) {
				state.selectedType = action.payload;
				return;
			}
			state.selectedType = initialState.selectedType;
		},
		setCollarType: (state, action: PayloadAction<string | null>) => {
			state.collarType = action.payload;
		},
		setMessage: (state, action: PayloadAction<string | null>) => {
			state.message = action.payload;
		},
		setPayment: (state, action: PayloadAction<PaymentTypeDef | null>) => {
			let previous = state.payment;
			let next = action.payload;
			if (!previous && next) {
				state.payment = action.payload;
				return;
			}
			if (previous && next && previous.id !== next.id) {
				state.payment = action.payload;
				return;
			}
			state.payment = initialState.payment;
		},
		setDelivery: (state, action: PayloadAction<DeliveryTypeDef | null>) => {
			let previous = state.delivery;
			let next = action.payload;
			if (!previous && next) {
				state.delivery = action.payload;
				return;
			}
			if (previous && next && previous.id !== next.id) {
				state.delivery = action.payload;
				state.dispatchPoint = initialState.dispatchPoint;
				return;
			}
			state.delivery = initialState.delivery;
		},
		setDispatchPoint: (state, action: PayloadAction<DispatchPoint | null>) => {
			state.dispatchPoint = action.payload;
		},
		setDiscountCode: (state, action: PayloadAction<string | null>) => {
			state.discountCode = action.payload;
		},
		setImageBase64: (state, action: PayloadAction<string | null>) => {
			state.imageBase64 = action.payload;
		},
		setCountry: (state, action: PayloadAction<AppLanguageCode>) => {
			state.country = action.payload;
		},
		setSourceRef: (state, action: PayloadAction<string | null>) => {
			state.sourceRef = action.payload;
		},
		resetStore: (_) => initialState,
	},
});



export const {
	setShowInvalids,
	setSizeA,
	setSizeB,
	setSizeC,
	setRace,
	setAge,
	setBehaviourDesc,
	setSurgerySegment,
	setIssueDesc,
	setSurgeryDate,
	setName,
	setEmail,
	setPhoneNumber,
	setStreet,
	setCity,
	setPostalCode,
	setInvoiceStreet,
	setInvoiceCity,
	setInvoicePostalCode,
	setSelectedType,
	setCollarType,
	setMessage,
	setPayment,
	setDelivery,
	setDispatchPoint,
	setDiscountCode,
	setImageBase64,
	setCountry,
	setSourceRef,
	resetStore } = orderSlice.actions;